import React from "react";

export default function RushPreparationSummary({
  groups = [], pendingOrders = [], loading = false, error = "", onRetry,
  onAcceptAll, actionBusy = false, allowAccept = true,
  selectedGroupKey = null, onSelectGroup,
}) {
  const selectable = typeof onSelectGroup === "function";
  const visibleGroups = groups.filter((group) => Number(group?.quantity) > 0);
  const outstanding = visibleGroups.reduce((total, group) => total + Number(group.quantity || 0), 0);
  const acceptDisabled = actionBusy || !allowAccept || pendingOrders.length === 0;
  return (
    <aside className="rush-prep-summary" aria-label="Outstanding preparation">
      <header className="rush-summary-header">
        <div><span className="rush-summary-eyebrow">Kitchen queue</span><h2>To prepare</h2></div>
        <span className="rush-summary-total" aria-label={error || (loading && !visibleGroups.length)
          ? "Preparation total unavailable" : `${outstanding} outstanding dishes`}>
          {error || (loading && !visibleGroups.length) ? "—" : outstanding}
        </span>
      </header>
      <div className="rush-summary-accept">
        <div><strong>{pendingOrders.length} new {pendingOrders.length === 1 ? "order" : "orders"}</strong><span>Awaiting acceptance</span></div>
        <button type="button" onClick={async () => {
          if (acceptDisabled || typeof onAcceptAll !== "function") return;
          try { await onAcceptAll(); } catch (_) { /* Shared decision hook reports failure. */ }
        }} disabled={acceptDisabled} aria-busy={actionBusy}>
          {actionBusy && <span className="loader kds-btn-loader" aria-hidden="true" />}
          {actionBusy ? "Accepting…" : "Accept all"}
        </button>
      </div>
      {error ? (
        <div className="rush-summary-state" role="alert">
          <span>Preparation totals unavailable.</span>
          {onRetry && (
            <button type="button" onClick={onRetry} disabled={loading} aria-busy={loading}>
              {loading && <span className="loader kds-btn-loader" aria-hidden="true" />}
              {loading ? "Retrying…" : "Retry"}
            </button>
          )}
        </div>
      ) : loading && !visibleGroups.length ? (
        <div className="rush-summary-skeleton" aria-label="Loading preparation totals" aria-busy="true">
          {[1, 2, 3, 4].map((key) => <div key={key} />)}
        </div>
      ) : (
        <div className="rush-summary-list">
          {visibleGroups.map((group) => (
            selectable ? (
              <button type="button" className={`rush-summary-row rush-summary-selectable${selectedGroupKey === group.key ? " is-selected" : ""}`}
                key={group.key} aria-pressed={selectedGroupKey === group.key}
                onClick={() => onSelectGroup(group.key)}>
                <span className="rush-summary-dish">{group.name}</span>
                <span className="rush-summary-qty" aria-label={`${group.quantity} outstanding`}>{group.quantity}</span>
                {Number(group.pendingQty) > 0 && <span className="rush-summary-breakdown">{group.pendingQty} new</span>}
                {Number(group.processingQty) > 0 && <span className="rush-summary-breakdown">{group.processingQty} accepted</span>}
              </button>
            ) : (
              <div className="rush-summary-row" key={group.key}>
                <span className="rush-summary-dish">{group.name}</span>
                <span className="rush-summary-qty" aria-label={`${group.quantity} outstanding`}>{group.quantity}</span>
                {Number(group.pendingQty) > 0 && <span className="rush-summary-breakdown">{group.pendingQty} new</span>}
                {Number(group.processingQty) > 0 && <span className="rush-summary-breakdown">{group.processingQty} accepted</span>}
              </div>
            )
          ))}
          {!visibleGroups.length && !loading && !error && (
            <div className="rush-summary-empty" role="status"><strong>Nothing outstanding</strong><span>Dish totals clear as tickets are completed.</span></div>
          )}
        </div>
      )}
      {loading && visibleGroups.length > 0 && <p className="rush-summary-refresh" role="status">Refreshing totals…</p>}
    </aside>
  );
}
